import { AiPieChart } from './ui/AiPieChart'
import { AiAreaChart } from './ui/AiAreaChart'
import { Square } from '../../utility/square/Square'
import React from 'react'
import { useAiChat } from '../ai-provider/AiProvider'
import { BpButton } from '../../buttons/bp-button/BpButton'
import { BpSelect } from '../../forms/select/BpSelect'
import { IconDocument } from '../../icons/IconDocument'
import { IconFolder } from '../../icons/IconFolder'
import { IconArrowUp } from '../../icons/IconArrowUp'
import { IconRefresh } from '../../icons/IconRefresh'
import { AiTable } from './ui/AiTable'
import { Tooltip } from 'antd'
import { Link } from 'react-router-dom'
import { AiBarChart } from './ui/AiBarChart'
import { Breadcrumbs } from '../../text/breadcrumbs/Breadcrumbs'

export const AiOverview = () => {
  const { size } = useAiChat()

  const mockDataPie = [
    { name: 'United states', value: 100, color: '#7A45E6' },
    { name: 'Germany', value: 40, color: '#FF3399' },
    { name: 'Russia', value: 50, color: '#ff0000' },
  ]
  const mockDataArea = [
    {
      name: 'Brand ads',
      color: '#7A45E6',
      data: [
        { time: '17.09', value: 30 },
        { time: '18.09', value: 50 },
        { time: '19.09', value: 40 },
      ],
    },
    {
      name: 'Affiliate ads',
      color: '#FF3399',
      data: [
        { time: '17.09', value: 0 },
        { time: '18.09', value: 60 },
        { time: '19.09', value: 170 },
      ],
    },
  ]
  const mockDataBar = [
    {
      name: 'Affiliates',
      color: '#FF3399',
      data: [
        { time: '17.09', value: 130 },
        { time: '18.09', value: 60 },
        { time: '19.09', value: 170 },
        { time: '20.09', value: 180 },
        { time: '21.09', value: 160 },
        { time: '22.09', value: 150 },
        { time: '23.09', value: 140 },
        { time: '24.09', value: 170 },
      ],
    },
  ]
  const mockDataTableKeywords = [
    { label: 'Pulsetto code1', count: 288 },
    { label: 'Pulsetto code2', count: 288 },
    { label: 'Pulsetto code3', count: 288 },
    { label: 'Pulsetto code4', count: 288 },
    { label: 'Pulsetto code5', count: 288 },
    { label: 'Pulsetto code6', count: 288 },
  ]
  const mockDataTable = [
    { label: 'utm_source=156713&utm_campaign=_bus', count: 288, difference: 19 },
    { label: 'utm_source=156713&utm_campaign=_bus', count: 288, difference: 19 },
    { label: 'utm_source=156713&utm_campaign=_bus', count: 288, difference: 19 },
    { label: 'utm_source=156713&utm_campaign=_bus', count: 288, difference: 19 },
    { label: 'utm_source=156713&utm_campaign=_bus', count: 288, difference: 19 },
  ]

  return (
    <div className='max-h-full flex-1 overflow-hidden bg-[#D9D9D91A]'>
      <div className='flex h-full flex-col'>
        <div className='scrollbar-hide flex flex-1 flex-col gap-[8px] overflow-y-auto'>
          <div className='flex h-full flex-col gap-[16px] overflow-y-auto px-[24px] pt-[16px] pb-[18px]'>
            <Square className='flex w-full flex-col gap-[16px] p-[24px]'>
              <div className={'text-[24px] text-focus-500'}>Affiliate Report</div>
              <div
                className={
                  'scrollbar-hide flex w-fit max-w-full gap-[8px] overflow-scroll rounded-[6px] border-[0.5px] border-[#0E63D8]/[0.25] p-[4px]'
                }
              >
                <button className={'rounded-[6px] py-[4px] px-[16px]'}>Today</button>
                <button className={'rounded-[6px] py-[4px] px-[16px]'}>Yesterday</button>
                <button className={'rounded-[6px] bg-grey-300 py-[4px] px-[16px]'}>Week</button>
                <button className={'rounded-[6px] py-[4px] px-[16px]'}>Month</button>
                <button className={'rounded-[6px] py-[4px] px-[16px]'}>Quarter</button>
              </div>
            </Square>
            <div className={`flex gap-[16px] ${{ large: 'flex-row', default: 'flex-col' }[size]}`}>
              <Square className='flex w-full flex-col gap-[8px] py-[12px] px-[24px]'>
                <div className={'text-[20px] text-focus-500'}>Total</div>
                <div className={'flex items-end gap-[4px] text-[24px] text-focus-500'}>
                  <span>17</span>
                  <div className={'flex items-center pb-[6px]'}>
                    <IconArrowUp className={'w-[18px]'} color={'#309700'} />
                    <span className={'text-[12px] text-success'}>+9</span>
                  </div>
                </div>
              </Square>
              <Square className='flex w-full flex-col gap-[8px] py-[12px] px-[24px]'>
                <div className={'text-[20px] text-focus-500'}>First time</div>
                <div className={'flex items-end gap-[4px] text-[24px] text-focus-500'}>
                  <span>1</span>
                  <div className={'flex items-center pb-[6px]'}>
                    <IconArrowUp className={'w-[18px]'} color={'#309700'} />
                    <span className={'text-[12px] text-success'}>+1</span>
                  </div>
                </div>
              </Square>
              <Square className='flex w-full flex-col gap-[8px] py-[12px] px-[24px]'>
                <div className={'text-[20px] text-focus-500'}>After resolved</div>
                <div className={'flex items-end gap-[4px] text-[24px] text-focus-500'}>
                  <span>0</span>
                </div>
              </Square>
            </div>
            <div className={`flex gap-[16px] ${{ large: 'flex-row', default: 'flex-col' }[size]}`}>
              <AiPieChart data={mockDataPie} subtitle={'Ads analyzed'} title={'Countries'} />
              <AiAreaChart
                data={mockDataArea}
                subtitle={'Ads analyzed'}
                title={'Your brand & affiliate ads'}
              />
            </div>
            <div className={`flex gap-[16px] ${{ large: 'flex-row', default: 'flex-col' }[size]}`}>
              <AiBarChart data={mockDataBar} subtitle={'Affiliates'} title={'Affiliates by week'} />
              <AiTable
                columns={[
                  {
                    title: 'Keyword',
                    dataIndex: 'label',
                    render: (label: string) => {
                      return (
                        <div>
                          <Tooltip title={label}>
                            <div className={'max-w-[150px] truncate text-[15px] text-focus-500'}>
                              {label}
                            </div>
                          </Tooltip>
                        </div>
                      )
                    },
                  },
                  { title: 'Affiliates', dataIndex: 'count', width: 50 },
                ]}
                data={mockDataTableKeywords}
                title={'Keywords used by affiliates'}
              />
            </div>
            <div>
              <AiTable
                columns={[
                  {
                    title: 'Affiliate',
                    dataIndex: 'label',
                    render: (label: string) => {
                      return (
                        <div>
                          <Tooltip title={label}>
                            <div
                              className={`truncate text-[15px] text-focus-500 ${{ large: 'max-w-full', default: 'max-w-[150px]' }[size]}`}
                            >
                              {label}
                            </div>
                          </Tooltip>
                          <Breadcrumbs>
                            <Link className={'text-[12px] text-focus'} to=''>
                              Promoted URL
                            </Link>
                            <Link className={'text-[12px] text-focus'} to=''>
                              SERP, Landing Screenshot
                            </Link>
                            <Link className={'text-[12px] text-focus'} to=''>
                              Partner link
                            </Link>
                            <Link className={'text-[12px] text-orange'} to=''>
                              Hijacker
                            </Link>
                          </Breadcrumbs>
                        </div>
                      )
                    },
                  },
                  {
                    title: 'Ads analyzed',
                    dataIndex: 'count',
                    width: 100,
                    render: (count: string, { difference }: any) => {
                      return (
                        <div className={'flex items-end gap-[4px] text-[15px] text-focus-500'}>
                          <span>{count}</span>
                          <div className={'flex items-center'}>
                            <span className={'text-[12px] text-success'}>+{difference}</span>
                            <IconArrowUp className={'w-[14px]'} color={'#309700'} />
                          </div>
                        </div>
                      )
                    },
                  },
                ]}
                data={mockDataTable}
                title={'Affiliates'}
              />
            </div>
          </div>
        </div>
        <div
          className={`flex gap-[8px] border-t-[0.5px] border-t-[#0E63D8]/[0.25] px-[24px] py-[16px] ${{ large: 'flex-row items-center', default: 'flex-col' }[size]}`}
        >
          <div className={{ large: 'w-[50%]', default: 'w-full' }[size]}>
            <BpSelect
              Icon={IconDocument}
              dropPosition={'auto'}
              fieldSize='lg'
              title={'AI-Generated Report '}
            />
          </div>
          <div className={{ large: 'w-[30%]', default: 'w-full' }[size]}>
            <BpSelect Icon={IconFolder} dropPosition={'auto'} fieldSize='lg' title={'Project'} />
          </div>
          <div className={{ large: 'w-[20%]', default: 'w-full' }[size]}>
            <BpButton
              className={'w-full uppercase'}
              iconLeft={<IconRefresh className={'w-[24px]'} />}
              size='lg'
              type='button'
            >
              Regenerate
            </BpButton>
          </div>
        </div>
      </div>
    </div>
  )
}
